var _circle, _circle2, _circle3, _circle4, _circle5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceImokay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    fill: "#EFD700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8807,
    cy: 78.8807,
    r: 20.8807,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8645,
    cy: 78.8807,
    r: 17.8977,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.119,
    cy: 78.8807,
    r: 20.8807,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.136,
    cy: 78.2841,
    r: 17.8977,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 131L128 131",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceImokay);
export default __webpack_public_path__ + "static/media/Face_Im okay.c3abb9ff1f19ff5d2c953d8afb19f5c5.svg";
export { ForwardRef as ReactComponent };